module.exports = __webpack_public_path__ + "img/bory-nove-bloky-logo.498710e4.png";